import 'client-only';

import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';

const getPaypalClient = () =>
  typeof window !== 'undefined' ? window['paypal'] : undefined;

const paypalClientAtom = atom<(typeof window)['paypal'] | undefined>(
  // If the PayPal script is already loaded, initialize the client immediately.
  getPaypalClient(),
);

/*
 * A hook to load/use the PayPal client.
 *
 * This can be used in as many places as needed. It will only load the Paypal script once and all usages of the hook will share the same client.
 */
export const usePayPalClient = () => {
  const [client, setClient] = useAtom(paypalClientAtom);

  useEffect(() => {
    if (document.getElementById('paypal-js')) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'paypal-js';
    script.src = 'https://www.paypalobjects.com/api/checkout.min.js';
    script.async = true;

    script.onload = () => {
      const paypalClient = getPaypalClient();

      if (paypalClient) {
        setClient(paypalClient);
      } else {
        console.error('Failed to initialize the Paypal client.');
      }
    };

    script.onerror = () => {
      console.error('Failed to load the Paypal script.');
    };

    document.body.appendChild(script);
  }, [setClient]);

  return client;
};
